module.exports = __webpack_public_path__ + "static/fonts/iconfont.5d67502.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.ttf?t=1627006594184
// module id = vqN4
// module chunks = 78